import React from 'react'
import { connect } from 'react-redux'
import { localizedTranslate } from 'assets/localization'
import 'less/interviews/no-interviews.less'

const TAB_CONFIG = {
  upcoming: {
    title: "There are currently no upcoming interviews.",
    moderatorKey: "modNoUpcomingString",
    pmKey: "pmNoUpcomingString",
  },
  completed: {
    title: "There are currently no completed interviews.",
    moderatorKey: "modNoCompletedString",
    pmKey: "pmNoCompletedString",
  },
  invalidate: {
    title: "There are currently no invalidated interviews.",
    moderatorKey: "modNoInvalidateString",
    pmKey: "pmNoInvalidateString",
  },
};

const NoInterviews = ({ tab, isModerator, t }) => {
  const config = TAB_CONFIG[tab];

  if (!config) {
    return null;
  }

  const descriptionText = isModerator
    ? t(config.moderatorKey)
    : t(config.pmKey);

  return (
    <div className="no-interviews-container">
      <div className="no-interviews-oval">
        <i className="im-ic-interview" />
      </div>

      <p className="there-are-currently">{config.title}</p>

      <hr />

      {!isModerator && <p className="description">{t("selectClient")}</p>}

      <p className="description">{descriptionText}</p>
    </div>
  );
}

const mapStateToProps = (state) => ({
  t: localizedTranslate("en", state.translations.en_us),
});

export default connect(mapStateToProps)(NoInterviews)
